module.exports = __webpack_public_path__ + "static/media/vf_msweater_core.1363c627.svg";